import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const sid = new URLSearchParams(hash.replace("#", "")).get("session_id");
    if (!sid) {
      navigate("/login", { replace: true });
      return;
    }
    (async () => {
      try {
        const intent = new URLSearchParams(window.location.search).get("g");
        const { data } = await api.post("/auth/google-session", { session_id: sid, intent });
        if (data.pending) {
          navigate("/login", { replace: true, state: { notice: data.message } });
          return;
        }
        setUser(data.user);
        const dest = data.user.role === "public" ? "/portal" : "/admin";
        try { if (data.user.role === "public") sessionStorage.setItem("rc_welcome", "1"); } catch { /* storage off */ }
        window.history.replaceState(null, "", dest);
        navigate(dest, { replace: true });
      } catch {
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center text-clinical font-heading text-xl">
      Signing you in…
    </div>
  );
}
